import redesignedTheme from '../../../theme/news12-redesign'

import css from 'styled-jsx/css'

export default css.div`
  .card {
    width: 348px;
    box-sizing: border-box;
    border-bottom: 1px solid ${redesignedTheme.colors.mist};
  }
  .card-title {
    line-height: 150%;
    color: ${redesignedTheme.colors.mineShaft};
    box-sizing: border-box;
  }  
  
  .top {
    display: none;
  }
  
  .image-container {
    display: none;
  }
`
